"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Resolve the localized entry for the provided config. Localizations should
 * be resolved in the following order:
 *
 * 1. check argument-based dictionary
 * 2. check global dictionary
 * 3. default to entry passed in config
 */
var getEntry = function (config) {
    var locale = exports.getCurrentLocale();
    if (config.dictionary && config.dictionary[locale]) {
        return config.dictionary[locale];
    }
    if (dictionaries[locale] && dictionaries[locale][config.singular]) {
        return dictionaries[locale][config.singular];
    }
    return config;
};
var dictionaries = {};
/**
 * `window.__i18nLocale` is offered as an *escape hatch* when you don't want to
 * go through all of your existing bundles to call `setLocale` before calling
 * `translate`.
 */
var currentLocale;
exports.getCurrentLocale = function () {
    if (!currentLocale && typeof window !== 'undefined') {
        currentLocale = window.__i18nLocale || '';
    }
    return currentLocale;
};
exports.setDictionaries = function (dicts) {
    dictionaries = dicts;
};
exports.setLocale = function (locale) {
    currentLocale = locale;
};
var interpolate = function (parts, replacements) {
    if (parts.length === 0) {
        return '';
    }
    // tslint:disable-next-line
    var head = parts[0], tail = parts.slice(1);
    var replacement;
    if (head[0] === '{' && head[head.length - 1] === '}') {
        var token = head.substring(1, head.length - 1);
        replacement = replacements[token];
        if (typeof replacement === 'function') {
            var closingTagIndex = tail.indexOf("{/" + token + "}");
            if (closingTagIndex === -1) {
                replacement = replacement();
            }
            else {
                var children = interpolate(tail.slice(0, closingTagIndex), replacements);
                replacement = replacement(children);
                tail = tail.slice(closingTagIndex + 1);
            }
        }
    }
    switch (typeof replacement) {
        case 'undefined':
            replacement = head;
            break;
        case 'number':
            replacement = replacement.toString();
            break;
    }
    var tailReplacements = interpolate(tail, replacements);
    if (typeof replacement === 'string' &&
        typeof tailReplacements === 'string') {
        return replacement + tailReplacements;
    }
    if (tailReplacements instanceof Array) {
        return [replacement].concat(tailReplacements);
    }
    return [replacement, tailReplacements];
};
var phraseForConfig = function (config) {
    var entry = getEntry(config);
    var phrase = entry.singular;
    if (config.hasOwnProperty('count') && config.count !== 1 && entry.plural) {
        phrase = entry.plural;
    }
    var parts = phrase.split(/({[\w\/]+})/g);
    if (!config.replacements) {
        if (parts.length > 1) {
            console.warn("Attempting to translate tokenized phrase without providing replacements:\n" + phrase);
        }
        return phrase;
    }
    return interpolate(parts, config.replacements);
};
exports.translate = function (config) {
    if (typeof config === 'string') {
        return phraseForConfig({ singular: config });
    }
    return phraseForConfig(config);
};
//# sourceMappingURL=translate.js.map